import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '../../../data/setup/initialState.erpProductSearch.data';
import {
  hardwareClass as hardwareClassAPI,
  productType as productTypeAPI,
  productSearch as productSearchAPI,
  generalInfoTab as generalInfoTabAPI,
  productFamily as productFamilyAPI,
  getSalesInfoTabData as getSalesInfoTabDataAPI,
  serviceInfoModel as serviceInfoModelAPI,
  serviceInfoSubModel as serviceInfoSubModelAPI,
  fetchServiceFee as fetchServiceFeeAPI,
  FetchserviceFeeGridData as FetchserviceFeeGridDataAPI,
  serviceProductDetails as serviceProductDetailsAPI,
  endOfServiceGridData as endOfServiceGridDataAPI,
  generalInfoSave as generalInfoSaveAPI,
  saveModesNSubModels as saveModesNSubModelsAPI,
  postServiceInfoFee as postServiceInfoFeeAPI,
  postEndOfService as postEndOfServiceAPI,
  serviceInfoModelDateValidate as serviceInfoModelDateValidateAPI,
  serviceInfoSubModelDateValidate as serviceInfoSubModelDateValidateAPI,
  eosModelAcceptButton as eosModelAcceptButtonAPI,
  eosJobRun as eosJobRunAPI,
} from '../../../apis/erpProductSearchAPI';
import { ACTIONS_ERP_PRODUCT } from '../../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { globalDateFormat } from '../../../utils/common';

export const handleEosModelAcceptButton = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.EOS_ACCEPT_BUTTON,
  eosModelAcceptButtonAPI
);

export const generalInfoTabData = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.GENERAL_INFO_TAB,
  generalInfoTabAPI
);

export const productFamily = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.PRODUCT_FAMILY,
  productFamilyAPI
);
export const salesInfoTabData = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.SALES_INFO_TAB,
  getSalesInfoTabDataAPI
);
export const serviceInfoModelData = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.SERVICE_INFO_MODEL,
  serviceInfoModelAPI
);

export const serviceInfoModelDateValidate = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SERVICE_INFO_MODEL_DATE_VALIDATION,
  serviceInfoModelDateValidateAPI
);

export const serviceInfoSubModelDateValidate = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SERVICE_INFO_SUBMODEL_DATE_VALIDATION,
  serviceInfoSubModelDateValidateAPI
);

export const serviceInfoSubModelData = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.SERVICE_INFO_SUBMODEL,
  serviceInfoSubModelAPI
);
export const fetchServiceFee = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.FETCH_SERVICE_FEE,
  fetchServiceFeeAPI
);

export const FetchserviceFeeGridData = createAsyncThunkWrapper(
  ACTIONS_ERP_PRODUCT.FETCH_SERVICE_GRID_DATA,
  FetchserviceFeeGridDataAPI
);
export const fetchServiceProductDetails = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SERVICE_PRODUCT_DETAILS,
  serviceProductDetailsAPI
);
export const fetchEndOfServiceGridData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.END_OF_SERVICE_GRID_DATA,
  endOfServiceGridDataAPI
);

export const saveGeneralInfo = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.GENERAL_INFO_SAVE,
  generalInfoSaveAPI
);

export const saveModelsNSubModelsData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SAVE_MODELS_N_SUBMODELS,
  saveModesNSubModelsAPI
);

export const saveServiceInfofee = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SAVE_SERVICE_INFO_FEE,
  postServiceInfoFeeAPI
);

export const saveEndOfService = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SAVE_END_OF_SERVICE,
  postEndOfServiceAPI
);

// API call for erp product search
export const allProducSearchData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SEARCH_ALL_PRODUCT,
  async (body, { rejectWithValue }) => {
    try {
      const response = await productSearchAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const productNameSearchData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SEARCH_PRODUCT_NAME_CONTAINS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await productSearchAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const productCodeContainSearchData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SEARCH_PRODUCT_CODE,
  async (body, { rejectWithValue }) => {
    try {
      const response = await productSearchAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const hardwareClassData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.FETCH_HARDWARE_CLASS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await hardwareClassAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const productTypeData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.GET_PRODUCT_TYPE,
  async (body, { rejectWithValue }) => {
    try {
      const response = await productTypeAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const priceClassContainSearchData = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.SEARCH_PRICE_CLASS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await productSearchAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const eosJobRun = createAsyncThunk(
  ACTIONS_ERP_PRODUCT.EOS_JOB,
  async (body, { rejectWithValue }) => {
    try {
      const response = await eosJobRunAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const ERPProductSearchSlice = createSlice({
  name: 'erpProductSearch',
  initialState,
  reducers: {
    setSelectedComponent: (state, action) => {
      state.selectedComponent = action?.payload;
      state.productCode = initialState.productCode;
      state.hardwareSearchTerm = initialState.hardwareSearchTerm;
      state.productTypeSearhTerm = initialState.productTypeSearhTerm;
      state.productNameSearchTerm = initialState.productNameSearchTerm;
      state.productCodeContainSearchTerm =
        initialState.productCodeContainSearchTerm;
      state.showProductCodeSelectedValue =
        initialState.showProductCodeSelectedValue;
      state.showProductnameSelectedValue =
        initialState.showProductnameSelectedValue;
      state.showProductTypeSelectedValue =
        initialState.showProductTypeSelectedValue;
      state.showHardwareClassSelectedValue =
        initialState.showHardwareClassSelectedValue;
      state.selectedValue = initialState.selectedValue;
      state.dropDownValues = initialState.dropDownValues;
      state.priceClassContainSearchTerm =
        initialState.priceClassContainSearchTerm;
      state.showPriceClassSelectedValue =
        initialState.showPriceClassSelectedValue;
      state.priceClassContains = initialState.priceClassContains;
    },
    modelInfoFlagSet: (state, action) => {
      state.ModelInfoFlag = action.payload;
    },
    feeFlagSet: (state, action) => {
      state.FeeFlag = action.payload;
    },
    serviceInfoFlagSet: (state, action) => {
      state.EndOfServiceFlag = action.payload;
    },
    setEntitlementFlag: (state, action) => {
      state.entitlementFlag = action.payload;
    },
    setSelectedRowData: (state, action) => {
      state.selectedRowData = action?.payload;
    },
    setHardwareClassSearchTerm: (state, action) => {
      state.hardwareSearchTerm = action?.payload;
    },
    setProductTypeSearchTerm: (state, action) => {
      state.productTypeSearhTerm = action?.payload;
    },
    setShowProductCodeSelectedValue: (state, action) => {
      state.showProductCodeSelectedValue = action?.payload;
    },
    setShowProductnameSelectedValue: (state, action) => {
      state.showProductnameSelectedValue = action?.payload;
    },
    setShowProductTypeSelectedValue: (state, action) => {
      state.showProductTypeSelectedValue = action?.payload;
    },
    setShowHardwareClassSelectedValue: (state, action) => {
      state.showHardwareClassSelectedValue = action?.payload;
    },
    setProductCodeContainSearchTerm: (state, action) => {
      state.productCodeContainSearchTerm = action?.payload;
    },
    setProductNameSearchTerm: (state, action) => {
      state.productNameSearchTerm = action?.payload;
    },
    setSelectedValue: (state, action) => {
      state.selectedValue[action?.payload.name] = action?.payload?.value;
    },
    setDropDownValue: (state, action) => {
      state.dropDownValues[action?.payload.name] = action?.payload?.value;
    },
    setSerachResultForDataGrid: (state, action) => {
      state.searhResultForDataGrid = action?.payload;
    },
    resetValues: (state) => {
      state.selectedComponent = initialState.selectedComponent;
      state.selectedRowData = initialState.selectedRowData;
      state.hardwareSearchTerm = initialState.hardwareSearchTerm;
      state.productNameSearchTerm = initialState.productNameSearchTerm;
      state.productCodeContainSearchTerm =
        initialState.productCodeContainSearchTerm;
      state.showProductCodeSelectedValue =
        initialState.showProductCodeSelectedValue;
      state.showProductnameSelectedValue =
        initialState.showProductnameSelectedValue;
      state.showProductTypeSelectedValue =
        initialState.showProductTypeSelectedValue;
      state.showHardwareClassSelectedValue =
        initialState.showHardwareClassSelectedValue;
      state.selectedValue = initialState.selectedValue;
      state.dropDownValues = initialState.dropDownValues;
      state.searhResultForDataGrid = initialState.searhResultForDataGrid;
      state.filterData = initialState.filterData;
      state.displayButtonValue = initialState.displayButtonValue;
      state.productCode = initialState.productCode;
      state.searchResult = initialState.searchResult;
      state.producCodeContains = initialState.producCodeContains;
      state.productName = initialState.productName;
      state.isDisplay = initialState.isDisplay;
      state.showSearchTerm = initialState.showSearchTerm;
      state.showProductCodeSelectedValue =
        initialState.showProductCodeSelectedValue;
      state.hardwareClasses = initialState.hardwareClasses;
      state.errorModal = null;
      state.priceClassContainSearchTerm =
        initialState.priceClassContainSearchTerm;
      state.showPriceClassSelectedValue =
        initialState.showPriceClassSelectedValue;
      state.priceClassContains = initialState.priceClassContains;
      state.saveAndCloseButton = initialState.saveAndCloseButton;
    },
    setFilterData: (state, action) => {
      state.filterData = action?.payload;
    },
    setDisplayButtonValue: (state, action) => {
      state.displayButtonValue = action?.payload;
    },
    setProductCode: (state, action) => {
      state.productCode = action?.payload;
    },
    setCloseAlertDialog: (state) => {
      state.alertBoxValue = false;
    },
    setShowPriceClassSelectedValue: (state, action) => {
      state.showPriceClassSelectedValue = action?.payload;
    },
    setPriceClassContainSearchTerm: (state, action) => {
      state.priceClassContainSearchTerm = action?.payload;
    },
    setSeviceInfoModelDataGrid: (state, action) => {
      state.serviceInfoTabModelData = action?.payload;
    },
    resetServiceInfoModelGridData: (state) => {
      state.serviceInfoTabModelData = [];
    },
    setServiceInfoSubmodelGridData: (state, action) => {
      state.serviceInfoTabModelData[state.selectedRowForModel?.id || 0][
        'serviceInfoTabSubModelData'
      ] = action?.payload;
    },
    resetServiceInfoSubModelGridData: (state) => {
      state.serviceInfoTabSubModelData = [];
    },
    setEndOfServceGrid: (state, action) => {
      state.endOfServicGridData = action?.payload;
    },
    deleteSerivceModel: (state, action) => {
      if (action?.payload?.addedOnUi) {
        state.serviceInfoTabModelData = state.serviceInfoTabModelData?.filter(
          (item) => item.id !== action?.payload?.id
        );
        state.ModelInfoFlag = false;
      } else {
        state.serviceInfoTabModelData = state.serviceInfoTabModelData?.map(
          (item) => {
            if (item.id === action?.payload?.id && !item?.addedOnUi) {
              item.isDeleted = true;
              item['serviceInfoTabSubModelData'] =
                item.serviceInfoTabSubModelData?.map((obj) => {
                  obj.isDeleted = true;
                  return obj;
                });
            }
            return item;
          }
        );
        state.ModelInfoFlag = true;
      }
    },
    deleteServiceSubModel: (state, action) => {
      let myData = JSON.parse(JSON.stringify(state.serviceInfoTabModelData));

      if (action?.payload?.addedOnUi) {
        state.serviceInfoTabModelData = myData?.map((ele) => {
          if (ele?.id === state?.selectedRowForModel?.id) {
            ele.serviceInfoTabSubModelData =
              ele?.serviceInfoTabSubModelData?.filter((item) => {
                if (item.id !== action?.payload?.id) {
                  return item;
                }
              });
          }
          return ele;
        });
        state.ModelInfoFlag = false;
      } else {
        state.serviceInfoTabModelData = myData?.map((ele) => {
          if (ele?.id === state?.selectedRowForModel?.id) {
            ele.serviceInfoTabSubModelData?.map((item) => {
              if (item?.id === action?.payload?.id && !item.addedOnUi) {
                item.isDeleted = true;
              }
              return item;
            });
          }
          return ele;
        });
        state.ModelInfoFlag = true;
      }
    },
    deleteEndOfServiceData: (state, action) => {
      if (action?.payload?.addedOnUi) {
        state.endOfServicGridData = state.endOfServicGridData?.filter(
          (item) => item.id !== action?.payload?.id
        );
        state.EndOfServiceFlag = false;
      } else {
        state.endOfServicGridData = state.endOfServicGridData?.map((item) => {
          if (item.id === action?.payload?.id && !item?.addedOnUi) {
            item.isDeleted = true;
            item.endOfServiceDate = item.oldEndOfServiceDate;
          }
          return item;
        });
        state.EndOfServiceFlag = true;
      }
    },

    setEndOfServiceBody: (state, action) => {
      state.endOfServiceBody[action?.payload?.name] = action?.payload?.value;
    },
    resetEndOfServiceBody: (state, action) => {
      state.endOfServiceBody = action?.payload;
    },
    setServiceInfoModelBody: (state, action) => {
      state.servceInfoModelBody = action?.payload;
    },
    setServiceInfoSubModelBody: (state, action) => {
      state.serviceInfoSubModelBody = action?.payload;
    },
    setSelectedRowForModel: (state, action) => {
      state.selectedRowForModel = action?.payload;
    },
    resetGeneralTabResponse: (state) => {
      state.generalInfoSaveResponse = initialState.generalInfoSaveResponse;
    },
    resetServiceInfoModeResponce: (state) => {
      state.saveModesNSubModelsResponse =
        initialState.saveModesNSubModelsResponse;
    },
    resetServiceInfoFeeResponse: (state) => {
      state.saveServiceInfoFeeResponse =
        initialState.saveServiceInfoFeeResponse;
    },
    resetServiceInfoEndOfServiceResponse: (state) => {
      state.saveEndOfServiceResponse = initialState.saveEndOfServiceResponse;
    },
    resetSubModelDateValidationData: (state) => {
      state.serviceSubModelDateValidationData = null;
    },
    resetModelDateValidationData: (state) => {
      state.serviceModelDateValidationData = null;
    },
    alertHandle: (state, action) => {
      state.showAlert = action?.payload;
    },
    resetSearchResult: (state) => {
      state.searchResult = [];
    },
    setEosModelGridData: (state, action) => {
      state.EosModelGridData = action?.payload;
    },
    acceptButtonResponse: (state, action) => {
      state.AcceptButtonResponse = action?.payload;
    },
    addExceptionSet: (state, action) => {
      state.addExceptionBtn = action?.payload;
    },
    oldDateSet: (state, action) => {
      state.oldDateEndOfService = action?.payload;
    },
    setcallOldDateApi: (state, action) => {
      state.callOldDateApi = action?.payload;
    },
    setLatestEos: (state, action) => {
      state.latestEos = action?.payload;
    },
    handleSaveAndCloseButton: (state, action) => {
      state.saveAndCloseButton = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hardwareClassData.pending, (state) => {
        state.loading = true;
        state.inputError = null;
      })
      .addCase(hardwareClassData.fulfilled, (state, action) => {
        state.loading = false;
        state.hardwareClasses = action?.payload || [];
      })
      .addCase(hardwareClassData.rejected, (state, action) => {
        state.loading = false;
        state.inputError = action?.payload;
      })
      .addCase(productTypeData.pending, (state) => {
        state.loading = true;
        state.inputError = null;
      })
      .addCase(productTypeData.fulfilled, (state, action) => {
        state.loading = false;
        state.productType = action?.payload || [];
      })
      .addCase(productTypeData.rejected, (state, action) => {
        state.loading = false;
        state.inputError = action?.payload;
      })

      .addCase(productCodeContainSearchData.pending, (state) => {
        state.loading = true;
        state.inputError = null;
      })
      .addCase(productCodeContainSearchData.fulfilled, (state, action) => {
        state.loading = false;
        state.producCodeContains = action?.payload || [];
      })
      .addCase(productCodeContainSearchData.rejected, (state, action) => {
        state.loading = false;
        state.inputError = action?.payload;
      })

      .addCase(productNameSearchData.pending, (state) => {
        state.loading = true;
        state.inputError = null;
      })
      .addCase(productNameSearchData.fulfilled, (state, action) => {
        state.loading = false;
        state.productName = action?.payload || [];
      })
      .addCase(productNameSearchData.rejected, (state, action) => {
        state.loading = false;
        state.inputError = action?.payload;
      })
      .addCase(allProducSearchData.pending, (state) => {
        state.loadingForSearch = true;
        state.inputError = null;
        state.isResultFound = true;
      })
      .addCase(allProducSearchData.fulfilled, (state, action) => {
        state.loadingForSearch = false;
        state.isResultFound = false;
        const payload = action?.payload;
        if (action?.meta?.arg?.exactMatch === true || state.selectedValue.exactMatch) {
          if (action?.payload) {
            if (state.entitlementFlag) {
              state.selectedRowData = payload?.[0]? payload[0] : payload;
              state.displayButtonValue = true;
            } else if (state.productCode !== '') {
              state.selectedRowData = payload;
              state.displayButtonValue = true;
            }
            state.errorModal = null;
          } else {
            (state.selectedRowData = []),
              (state.alertBoxValue = true),
              (state.errorModal = action.meta?.arg?.productCode
                ? action.meta?.arg?.productCode
                : 'enterValue'),
              (state.displayButtonValue = false);
          }
        } else {
          state.searchResult = payload;
        }
      })
      .addCase(allProducSearchData.rejected, (state, action) => {
        state.loadingForSearch = false;
        state.isResultFound = false;
        state.inputError = action?.payload;
      })

      //handle price clas contain
      .addCase(priceClassContainSearchData.pending, (state) => {
        state.loading = true;
        state.inputError = null;
      })
      .addCase(priceClassContainSearchData.fulfilled, (state, action) => {
        state.loading = false;
        state.priceClassContains = action?.payload || [];
      })
      .addCase(priceClassContainSearchData.rejected, (state, action) => {
        state.loading = false;
        state.inputError = action?.payload;
      })
      // handle Display page
      .addCase(generalInfoTabData.pending, (state) => {
        state.generalInfoLoading = true;
        state.generalInfoTabData = [];
      })
      .addCase(generalInfoTabData.fulfilled, (state, action) => {
        state.generalInfoLoading = false;
        state.generalInfoTabData = action?.payload || [];
        state.oldObjGeneralInfo = {
          productId: state?.selectedRowData?.id,
          unsupportedFlag: action?.payload?.unsupportedFlag || 'n',
          upgradeFlag: action?.payload?.upgradeFlag,
          billClassId: action?.payload?.billClassId,
          modelId: action?.payload?.modelId,
          modelInfo: action?.payload?.modelInfo,
        };
      })
      .addCase(generalInfoTabData.rejected, (state) => {
        state.generalInfoLoading = false;
        state.generalInfoTabData = [];
      })
      .addCase(productFamily.pending, (state) => {
        state.productFamilyLoading = true;
        state.productFamilyData = [];
      })
      .addCase(productFamily.fulfilled, (state, action) => {
        state.productFamilyLoading = false;
        state.productFamilyData = action?.payload[0]?.billClasses || [];
      })
      .addCase(productFamily.rejected, (state) => {
        state.productFamilyLoading = false;
        state.productFamilyData = [];
      })
      .addCase(salesInfoTabData.pending, (state) => {
        state.salesInfoLodading = true;
        state.salesInfoTabData = [];
        state.salesInfoTotalCount = 0;
      })
      .addCase(salesInfoTabData.fulfilled, (state, action) => {
        state.salesInfoLodading = false;
        state.salesInfoTabData = action?.payload || [];
        state.salesInfoTotalCount = action?.payload[0]?.totalRecords;
      })
      .addCase(salesInfoTabData.rejected, (state) => {
        state.salesInfoLodading = false;
        state.salesInfoTabData = [];
        state.salesInfoTotalCount = 0;
      })
      .addCase(serviceInfoModelData.pending, (state) => {
        state.serviceInfoModelLoading = true;
        state.serviceInfoTabModelData = [];
        state.serviceInfoModelDataFound = null;
      })
      .addCase(serviceInfoModelData.fulfilled, (state, action) => {
        state.serviceInfoModelLoading = false;
        state.serviceInfoTabModelData =
          action?.payload?.serviceProductModels?.map((item, index) => {
            item.id = index;
            item.oldEffectiveDate = item?.effectiveDate;
            item.effectiveDate = globalDateFormat(item?.effectiveDate);
            item.isInserted = false;
            item.isDeleted = false;
            item.addedOnUi = false;
            return item;
          }) || [];
        state.oldObhServiceInfoModel =
          action?.payload?.serviceProductModels || [];
        state.totalCountForModel = action?.payload?.totalRecords;
        state.serviceInfoModelDataFound = true;
      })
      .addCase(serviceInfoModelData.rejected, (state) => {
        state.serviceInfoModelLoading = false;
        state.serviceInfoTabModelData = [];
        state.serviceInfoModelDataFound = false;
      })
      .addCase(serviceInfoSubModelData.pending, (state) => {
        state.serviceInfoSubModelLoading = true;
        state.serviceInfoTabSubModelData = [];
        state.totalCountForSubModel = 0;
      })
      .addCase(serviceInfoSubModelData.fulfilled, (state, action) => {
        state.serviceInfoSubModelLoading = false;
        let serviceInfoTabSubModelData =
          action?.payload?.serviceProductSubModels?.map((item, index) => {
            item.id = index;
            item.oldSubModelEffectiveDate = item?.subModelEffectiveDate;
            item.subModelEffectiveDate = globalDateFormat(
              item?.subModelEffectiveDate
            );
            item.isInserted = false;
            item.isDeleted = false;
            item.addedOnUi = false;
            return item;
          }) || [];
        state.serviceInfoTabModelData = state.serviceInfoTabModelData.map(
          (item, index) => {
            if (
              index === state?.selectedRowForModel?.id &&
              !item.serviceInfoTabSubModelData
            ) {
              item['serviceInfoTabSubModelData'] = serviceInfoTabSubModelData
                ? serviceInfoTabSubModelData
                : [];
            }
            return item;
          }
        );
        state.oldObjServiceInfoSubModel =
          action?.payload?.serviceProductSubModels || []; // could be reomoved
        state.totalCountForSubModel = action?.payload?.totalRecords;
      })
      .addCase(serviceInfoSubModelData.rejected, (state) => {
        state.serviceInfoSubModelLoading = false;
        state.serviceInfoTabSubModelData = [];
        state.totalCountForSubModel = 0;
      })
      .addCase(fetchServiceFee.pending, (state) => {
        state.serviceFeeData = [];
      })
      .addCase(fetchServiceFee.fulfilled, (state, action) => {
        state.serviceFeeData = action?.payload;
        state.oldObjServiceInfoFee = action?.payload?.serviceFee;
      })
      .addCase(fetchServiceFee.rejected, (state) => {
        state.serviceFeeData = [];
      })
      .addCase(FetchserviceFeeGridData.pending, (state) => {
        state.serviceFeeGridData = [];
        state.serviceFeeGridLoading = true;
        state.hardwareFeeTotalCount = 0;
      })
      .addCase(FetchserviceFeeGridData.fulfilled, (state, action) => {
        state.serviceFeeGridData = action?.payload?.hardwareFees?.map(
          (item, index) => {
            item.id = index;
            return item;
          }
        );
        state.hardwareFeeTotalCount = action?.payload?.totalRecords;

        state.serviceFeeGridLoading = false;
      })
      .addCase(FetchserviceFeeGridData.rejected, (state) => {
        state.serviceFeeGridData = [];
        state.hardwareFeeTotalCount = 0;
        state.serviceFeeGridLoading = false;
      })
      .addCase(fetchServiceProductDetails.pending, (state) => {
        state.serviceProductData = [];
        state.receivedOldEos = false;
      })
      .addCase(fetchServiceProductDetails.fulfilled, (state, action) => {
        state.serviceProductData = action?.payload?.data;
        state.oldDateEndOfService = action?.payload?.data?.endOfServiceDate;
        state.oldDateEndOfServiceForJob =
          action?.payload?.data?.endOfServiceDate;
        state.receivedOldEos = true;
      })
      .addCase(fetchServiceProductDetails.rejected, (state) => {
        state.serviceProductData = [];
      })
      .addCase(fetchEndOfServiceGridData.pending, (state) => {
        state.endOfServicGridData = [];
        state.receivedOldEos = false;
        state.endOfServceLoading = true;
        state.endOfServiceTotalCount = 0;
      })
      .addCase(fetchEndOfServiceGridData.fulfilled, (state, action) => {
        state.endOfServicGridData =
          action?.payload?.data?.serviceProductModels?.map((item, index) => {
            item.id = index;
            item.oldEndOfServiceDate = new Date(item?.endOfServiceDate);
            item.endOfServiceDate = new Date(item?.endOfServiceDate);
            item.isInserted = false;
            item.isDeleted = false;
            item.addedOnUi = false;
            return item;
          }) || [];
        state.endOfServceLoading = false;
        state.endOfServiceTotalCount = action?.payload?.data?.totalRecords;
      })
      .addCase(fetchEndOfServiceGridData.rejected, (state) => {
        state.endOfServicGridData = [];
        state.endOfServceLoading = false;
        state.endOfServiceTotalCount = 0;
      })

      .addCase(saveGeneralInfo.pending, (state) => {
        state.generalInfoSaveResponse = null;
      })
      .addCase(saveGeneralInfo.fulfilled, (state, action) => {
        state.generalInfoSaveResponse = action?.payload?.data;
      })
      .addCase(saveGeneralInfo.rejected, (state) => {
        state.generalInfoSaveResponse = false;
      })
      .addCase(saveModelsNSubModelsData.pending, (state) => {
        state.saveModesNSubModelsResponse = null;
      })
      .addCase(saveModelsNSubModelsData.fulfilled, (state, action) => {
        state.saveModesNSubModelsResponse = action?.payload;
      })
      .addCase(saveModelsNSubModelsData.rejected, (state) => {
        state.saveModesNSubModelsResponse = false;
      })

      .addCase(saveServiceInfofee.pending, (state) => {
        state.saveServiceInfoFeeResponse = null;
      })
      .addCase(saveServiceInfofee.fulfilled, (state, action) => {
        state.saveServiceInfoFeeResponse = true;
      })
      .addCase(saveServiceInfofee.rejected, (state) => {
        state.saveServiceInfoFeeResponse = false;
      })
      .addCase(saveEndOfService.pending, (state) => {
        state.saveEndOfServiceResponse = null;
        state.endOfServicGridData = [];
        state.receivedOldEos = false;
        state.endOfServceLoading = true;
        state.endOfServiceTotalCount = 0;
      })
      .addCase(saveEndOfService.fulfilled, (state, action) => {
        state.saveEndOfServiceResponse = action?.payload;
      })
      .addCase(saveEndOfService.rejected, (state) => {
        state.saveEndOfServiceResponse = false;
      })
      .addCase(serviceInfoModelDateValidate.pending, (state) => {
        state.serviceModelDateValidationData = null;
      })
      .addCase(serviceInfoModelDateValidate.fulfilled, (state, action) => {
        state.serviceModelDateValidationData = action?.payload?.data
          ?.serviceProductModels
          ? action?.payload?.data?.serviceProductModels
          : [];
      })
      .addCase(serviceInfoModelDateValidate.rejected, (state) => {
        state.serviceModelDateValidationData = [];
      })
      .addCase(serviceInfoSubModelDateValidate.pending, (state) => {
        state.serviceSubModelDateValidationData = null;
      })
      .addCase(serviceInfoSubModelDateValidate.fulfilled, (state, action) => {
        state.serviceSubModelDateValidationData = action?.payload?.data
          ?.serviceProductSubModels
          ? action?.payload?.data?.serviceProductSubModels
          : [];
      })
      .addCase(serviceInfoSubModelDateValidate.rejected, (state) => {
        state.serviceSubModelDateValidationData = [];
      })

      .addCase(eosJobRun.pending, (state) => {
        state.eosJobRunLoad = true;
        state.eosJobRunData = null;
        state.showAlert = false;
      })
      .addCase(eosJobRun.fulfilled, (state, action) => {
        state.eosJobRunLoad = false;
        state.eosJobRunData = action?.payload;
        state.showAlert = true;
      })
      .addCase(eosJobRun.rejected, (state) => {
        state.eosJobRunLoad = false;
        state.eosJobRunData = null;
        state.showAlert = false;
      })

      .addCase(handleEosModelAcceptButton.pending, (state) => {
        state.AcceptButtonResponse = true;
      })
      .addCase(handleEosModelAcceptButton.fulfilled, (state, action) => {
        state.AcceptButtonResponse = action?.payload;
        state.oldDateEndOfService = null;
      })
      .addCase(handleEosModelAcceptButton.rejected, (state) => {
        state.AcceptButtonResponse = false;
      });
  },
});

export const {
  setSelectedComponent,
  setHardwareClassSearchTerm,
  setSelectedValue,
  resetValues,
  setProductTypeSearchTerm,
  setProductCodeContainSearchTerm,
  setProductNameSearchTerm,
  setFilterData,
  setDropDownValue,
  setSerachResultForDataGrid,
  setSelectedRowData,
  setShowProductCodeSelectedValue,
  setShowProductnameSelectedValue,
  setShowProductTypeSelectedValue,
  setShowHardwareClassSelectedValue,
  setDisplayButtonValue,
  setProductCode,
  setCloseAlertDialog,
  setShowPriceClassSelectedValue,
  setPriceClassContainSearchTerm,
  setSeviceInfoModelDataGrid,
  resetServiceInfoModelGridData,
  setServiceInfoSubmodelGridData,
  resetServiceInfoSubModelGridData,
  deleteSerivceModel,
  deleteServiceSubModel,
  setServiceInfoModelBody,
  setServiceInfoSubModelBody,
  deleteEndOfServiceData,
  setEndOfServiceBody,
  setEndOfServceGrid,
  resetEndOfServiceBody,
  setSelectedRowForModel,
  resetGeneralTabResponse,
  resetServiceInfoModeResponce,
  resetServiceInfoFeeResponse,
  resetServiceInfoEndOfServiceResponse,
  resetSubModelDateValidationData,
  resetModelDateValidationData,
  alertHandle,
  setEntitlementFlag,
  resetSearchResult,
  modelInfoFlagSet,
  feeFlagSet,
  serviceInfoFlagSet,
  setEosModelGridData,
  acceptButtonResponse,
  addExceptionSet,
  oldDateSet,
  setcallOldDateApi,
  setLatestEos,
  handleSaveAndCloseButton,
} = ERPProductSearchSlice.actions;
export default ERPProductSearchSlice.reducer;
